export default __webpack_public_path__ + "static/media/detail_mobile_12_3.75a6ec93.jpg";